import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loader from "react-loader-spinner";
import { FiDownload } from 'react-icons/fi';
import { useTranslation } from "react-i18next";
import RichTextEditor from 'react-rte';
import * as jobsActions from '../../Redux/Actions/jobs';
import * as commonActions from '../../Redux/Actions/common';
import * as addtionalPaymentsActions from '../../Redux/Actions/additionalPayments';
import { toastMessage } from '../../utils/toast';
import { clearSession } from '../../utils/initiate';
import ReferenceList from './referenceList';
import ReferenceModal from './referenceModal';
import ReferenceStatusModal from './referenceStatusModel';
import ReceiptModal from './receiptModal';
import StatusModal from './statusModal';
import { getDocumentLabel, downloadFile, dateTimeFormat } from '../../utils';
import CreateNoteModal from './createNoteModal';
import SubProcessList from './subProcessList';
import { initiateLogOut } from '../../utils/initiate';
import AdditionalPayment from './additionalPayment';
import StatusLog from '../../utils/statusLog';
import CustomDocumentModal from './customDocumentModal';
import DocumentDisplay from '../../utils/documentDisplay';
import { resetFileName } from '../../utils/resetFileName';
import CONFIG from '../../config';
import PaymentLink from './paymentLink';

const JobInfo = ({ history, match }) => {
    const [data, setData] = useState([]);
    const [fileArr, setFileArr] = useState([]);
    const [vendorDocArr, setVendorDocArr] = useState([]);
    const [loading, setLoading] = useState(false);
    const [referenceModal, setReferenceModal] = useState(false);
    const [referenceStatusModal, setReferenceStatusModal] = useState(false);
    const [receiptModal, setReceiptModal] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [zipLoading, setZipLoading] = useState(false);
    const [zipLoading1, setZipLoading1] = useState(false);
    const [zipLoading2, setZipLoading2] = useState(false);
    const [referenceEditData, setReferenceEditData] = useState({});
    const [receiptData, setReceiptData] = useState([]);
    const [receiptOptions, setReceiptOptions] = useState([]);
    const [referenceReceiptList, setReferenceReceiptList] = useState([]);
    const [documentReason, setDocumentReason] = useState({});
    const [status, setStatus] = useState('');
    const [comment, setComment] = useState(RichTextEditor.createEmptyValue());
    const [statusModal, setStatusModal] = useState(false);
    const [displayData, setDisplayData] = useState({});
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { jobID } = match.params;
    const [createNoteModal, setCreateNoteModal] = useState(false);
    const [note, setNote] = useState('');
    const [isReadMore, setIsReadMore] = useState('');
    const [statusList, setStatusList] = useState([]);
    const [mailDocuments, setMailDocuments] = useState([]);
    const userData = useSelector(({ User }) => User.data);
    const [subjectOptions, setSubjectOptions] = useState([]);
    const [subject, setSubject] = useState('');
    const [subData, setSubData] = useState([]);
    const [additionalPaymentInfo, setAdditionalPaymentInfo] = useState('');
    const [updateStatus, setUpdateStatus] = useState('');
    const [statusLog, setStatusLog] = useState([]);
    const [customDocumentModal, setCustomDocumentModal] = useState(false);
    const [paymentLink, setPaymentLink] = useState(false);
    const [customDocArr, setCustomDocArr] = useState([]);
    const [corporateJobDocumentFileArr, setCorporateJobDocumentFileArr] = useState([]);

    
    useEffect(() => {
        setLoading(true);
        jobsActions.getIndividual(jobID).then(res => {
            if(res && res.data){

                
                setData(res.data);
                setReferenceReceiptList(res.data.jobInfo.references);
                let tempFileArr = [];
                let documentArr = res.data.jobInfo.json && JSON.parse(res.data.jobInfo.json) && JSON.parse(res.data.jobInfo.json).documents;

                handleVendorDocuments(res.data.vendorDocuments);
                if (Object.entries(documentArr).length !== 0) {
                    let j = 0;
                    Object.entries(documentArr).map(([key, value]) =>
                        ((value.length > 0) || (value !== null)) && jobsActions.getDocumentMetaData(res.data.customerInfo.id, value).then(res => {
                            let documentData = res.data;
                            documentData.forEach((ele, i) => {
                                tempFileArr.push({ key: key + '' + i, ...ele });
                            });

                            (j === Object.entries(documentArr).length - 1) && setFileArr(tempFileArr);
                            setLoading(false);
                            j++;
                        }).catch(err => {
                            setLoading(false);
                            console.log('Unable to get documents meta data', err);
                        })
                    );
                } else {
                    setLoading(false);
                }


                // Corporate documents start
                let corporateDocsTempFileArr = [];
                ((res.data.corporateJobDocuments !=null)) && jobsActions.getMetaDataPaymentReceipt(res.data.corporateJobDocuments).then(res1 => {
                    let corporateDocumentData = res1.data;
                    let j1=0;
                    var key1="";
                    corporateDocumentData.forEach((ele, i) => {
                        corporateDocsTempFileArr.push({key: key1 + '' + i, ...ele});
                    });
                console.log(corporateDocsTempFileArr);
                    (Object.entries(corporateDocumentData).length >0) && setCorporateJobDocumentFileArr(corporateDocsTempFileArr);
                    setLoading(false);
                    j1++;
                    
                }).catch(err => {
                    setLoading(false);
                    console.log('Unable to get documents meta data', err);
                })
            // Corporate documents End
            } else {
                setLoading(false);
                toastMessage('error', (res && res.message) || `Unable to get the job info`);
            }
        }).catch(err => {
            setLoading(false);
            (err.response.status === 401) && clearSession(dispatch, history);
        });

        jobsActions.statusesForTypingCenter().then(({ data }) => {
            if (data) {
                setStatusList(data);
            }
        }).catch(err => {
            toastMessage('error', `Unable to get the job statuses`);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });
        handleLoadReferenceReceiptOptions();
        getDocumentsById();
        handleLoadSubjectOptions();
        handleSubProcessData();
        AdditionalPaymentRequestsByJob(jobID);
        getUpdateStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobID, history]);

    useEffect(() => {
        setDisplayData(getDisplayData);
        const statusInfo = data?.stausInfo?.map(({ logData, time }) => {
            let parsedLogData = JSON.parse(logData);
            return { ...{ comments: parsedLogData.Commments, createdTime: time, message: parsedLogData.ToStatus } }
        });
        setStatusLog(statusInfo);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, jobID]);
    let jobData = data.jobInfo && JSON.parse(data.jobInfo.json);

    const AdditionalPaymentRequestsByJob = (id) => {
        addtionalPaymentsActions.additionalPaymentRequests(id).then((res) => {
            if (res?.data) {
                setAdditionalPaymentInfo(res.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const getUpdateStatus = () => {
        addtionalPaymentsActions.getAllAdditionalJobStatuses().then((res) => {
            if (res?.data) {
                let data = res.data;
                let options = data.map(({ value, lable }) => ({ label: lable, value: value }));
                setUpdateStatus(options);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const getDisplayData = () => {
        let newData = {};
        let job = data.jobInfo && JSON.parse(data.jobInfo.json).data;
        if (job === null || job === undefined) return;
        for (let [key, value] of Object.entries(job)) {
            if (!key.includes('+')) {
                newData = { [key.charAt(0).toUpperCase() + key.slice(1)]: value, ...newData };
            } else {
                let fieldName = key.split(/\+/);
                if (typeof value === 'boolean') {
                    value = value === true ? 'Yes' : 'No';
                }
                newData[(key.includes('+') ? fieldName[0] : key)] = value;
            }
        }
        return newData;
    };

    const handleSubProcessData = () => {
        jobsActions.getSubProcessList(jobID).then(res => {
            if (res && res.data) {
                setSubData(res.data);
            } else {
                toastMessage('error', (res && res.message) || 'Try again later');
            }
        }).catch(err => {
            toastMessage('error', (err && err.message) || 'Try again later');
        });

    }

    const handleDownloadDocument = (documentID) => {
        jobsActions.documentDownload(data.customerInfo.id, documentID).then(res => {
            let binary_string = window.atob(res.data.content);
            let len = binary_string.length;
            let bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            let blob = new Blob([bytes], { type: "text/plain" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = res.data.fileName;
            link.click();
        }).catch((err) => {
            console.log('Something Went Wrong', err);
        })
    };

    const handleLoadReferenceReceiptOptions = () => {
        jobsActions.jobAttributes(jobID).then(({ data }) => {
            if (data && data.jobAttributes) {
                setReceiptData(data.jobAttributes);
                let filteredJobAttributes = data.jobAttributes.filter(({ moduleType }) => moduleType !== 'AAMER_ENTITY');
                filteredJobAttributes = filteredJobAttributes.map(({ name }) => ({ label: name, value: name }));
                setReceiptOptions(filteredJobAttributes);
            }
        }).catch(err => {
            toastMessage('error', `Unable to get the job attributes`);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    };

    const handleDownloadAllDocument = (type) => {
        let docArr = [];
        if (type === 'vendor') {
            setZipLoading1(true);
            docArr = vendorDocArr.map(({ documentId }) => ({ documentId, userId: 2 }));
        } else if (type === 'custom') {
            setZipLoading2(true);
            docArr = customDocArr.map(({documentId}) => ({documentId, userId:2}));
        }else if(type === 'corporate') {
            setZipLoading2(true);
            docArr = corporateJobDocumentFileArr.map(({documentId}) => ({documentId, userId:2}));
        } else {
            setZipLoading(true);
            docArr = fileArr.map(({ documentId }) => ({ documentId, userId: data.customerInfo.id }));
        }
        jobsActions.downloadZipDocument(docArr).then(res => {
            res && downloadFile(res, jobID, type);
            setZipLoading(false);
            setZipLoading1(false);
            setZipLoading2(false);
        }).catch(err => {
            toastMessage('error', (err && err.message) || 'Unable to download all documents');
        });
    };

    const handleVendorDocuments = (documents) => {
        let tempFileArr = [];
        if (documents) {
            documents.map(value =>
                ((value.length > 0) || (value !== null)) && jobsActions.getMetaDataPaymentReceipt(value).then(res => {
                    let documentData = res.data[0];
                    tempFileArr.push(documentData);
                    (tempFileArr.length === documents.length) && setVendorDocArr(tempFileArr);
                    dispatch(commonActions.pageLoading(false));
                }).catch(err => {
                    dispatch(commonActions.pageLoading(false));
                    console.log('Unable to get documents meta data', err);
                })
            );
        }
    };

    const handleUpdateReferenceStatus = (referenceEditData) => {
        setButtonLoading(true);
        jobsActions.updateReferenceStatus(referenceEditData).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Job reference status updated successfully');
                setReferenceStatusModal(false);
                setButtonLoading(false);
                window.location.reload();
            } else {
                setButtonLoading(false);
                toastMessage('error', (res && res.message) || 'Try again later');
            }
        });
    };

    const handleUpdateReference = (referenceData) => {
        setButtonLoading(true);
        let payload = {
            jobId: data.jobInfo.jobId,
            reference: referenceData
        };
        jobsActions.updateReference(payload).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Job references updated successfully');
                setReferenceModal(false);
                window.location.reload();
            } else {
                toastMessage('error', (res && res.message) || 'Try again later');
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || 'Try again later');
        });
    };

    const handleDownloadPaymentReceipt = (documentID) => {
        jobsActions.downloadPaymentReceipt(documentID).then(res => {
            res && downloadFile(res);
        }).catch((err) => {
            console.log('Something Went Wrong', err);
        });
    };

    const handleJobClosureApproval = () => {
        setButtonLoading(true);
        jobsActions.jobClosureApproval(data.jobInfo.jobId, status === 'RequestCompletion', comment.toString('html')).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Job status updated successfully');
                setComment(RichTextEditor.createEmptyValue());
                setStatusModal(false);
                window.location.reload();
            } else {
                toastMessage('error', (res && res.message) || 'Try again later');
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || `Unable to update the job status`);
        });
    };

    const handleUpdateStatus = () => {
        setButtonLoading(true);
        const payload = {
            Comment: comment.toString('html'),
            jobId: data.jobInfo.jobId,
            status
        }

        jobsActions.updateJobStatus(payload).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Job status updated successfully');
                setComment(RichTextEditor.createEmptyValue());
                setStatusModal(false);
                window.location.reload();
            } else {
                toastMessage('error', (res && res.message) || 'Try again later');
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || `Unable to update the job status`);
        });
    }

    const handleDocumentReason = (document, value) => {
        setDocumentReason({ ...documentReason, [document]: value });
    };

    const handleCreateNote = () => {
        setButtonLoading(true);
        if (note.trim() === '') {
            toastMessage('error', 'Please enter valid note.');
            setButtonLoading(false);
        }
        else {
            let payload = {
                JobId: data.jobInfo.jobId,
                note: note
            };
            jobsActions.createJobNote(payload).then(res => {
                if (res && res.data) {
                    toastMessage('success', 'Note added successfully.');
                    setCreateNoteModal(false);
                    window.location.reload();
                } else {
                    toastMessage('error', (res && res.message) || 'Try again later');
                }
                setButtonLoading(false);
            }).catch(err => {
                setButtonLoading(false);
                toastMessage('error', (err && err.message) || 'Try again later');
            });
        }
    };

    const handleUpdateEmailDocuments = () => {
        setButtonLoading(true);
        // let formattedSubject = `AAD-${data.jobInfo.jobId} : ${data.jobInfo.processName} : ${subject.value}`;
        let formattedSubject = `AAD-${data.jobInfo.jobId} : ${data.jobInfo.processName} : ${subjectOptions[0].value}`;
        let Comment = comment.toString('html');
        let maildata = new FormData();
        maildata.append('Subject', formattedSubject);
        maildata.append('body', Comment);
        maildata.append('tag', 'EmailDocuments');
        for (let i = 0; i <= mailDocuments.length; i++) {
            if (mailDocuments[i] !== undefined) {
                maildata.append('files', resetFileName(mailDocuments[i]));
                let woExtensionName = mailDocuments[i] && mailDocuments[i].name.toLowerCase().split('.');
                maildata.append('fileNames', woExtensionName[0] + '.' + woExtensionName[woExtensionName.length - 1]);
                maildata.append('extensions', '.' + woExtensionName[woExtensionName.length - 1]);
            }
        }

        jobsActions.sendJobMail(maildata, data.jobInfo.jobId).then(res => {
            if (res && res.data) {
                toastMessage('success', (res.message && res.message) || 'Mail send successfully');
                setSubject('');
                setComment(RichTextEditor.createEmptyValue());
                setMailDocuments([]);
                setButtonLoading(false);
                setStatusModal(false);
                window.location.reload();
            }
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || 'Unable to send the email documents');
        });
    }

    const handleLoadSubjectOptions = () => {
        // jobsActions.jobAttributes(jobID).then(({data}) => {
        //     if(data && data.jobAttributes){
        //         setReceiptData(data.jobAttributes);
        //         let filteredSubOptions = data.jobAttributes.filter(({moduleType}) => moduleType !== 'AAMER_ENTITY');
        //         filteredSubOptions = filteredSubOptions.map(({name, moduleType}) => ({label: name, value: moduleType}));
        //         setSubjectOptions(filteredSubOptions);
        //     }
        // }).catch(err => {
        //     toastMessage('error', `Unable to get the email subject options`);
        //     (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        // });
        setSubjectOptions([{ label: 'Document Update', value: 'Document Update' }]);
    };

    // const handleCreateDeliveryReq = () => {
    //     window.open(`${data.deliveryRequestUrl}&token=${window.localStorage.jwt}`, '_blank');
    // };

    const getDocumentsById = () => {
        jobsActions.getBackOfficeDocumentIds(jobID).then(({ data }) => {
            let tempFileArr = [];
            if (data?.length) {
                data?.map(value =>
                    ((value.length > 0) || (value !== null)) && jobsActions.getMetaDataPaymentReceipt(value).then(res => {
                        let documentData = res.data[0];
                        tempFileArr.push(documentData);
                        (tempFileArr.length === data.length) && setCustomDocArr(tempFileArr);
                        dispatch(commonActions.pageLoading(false));
                    }).catch(err => {
                        dispatch(commonActions.pageLoading(false));
                        console.log('Unable to get documents meta data', err);
                    })
                );
            }
        })
    }
    return (
        <div className="container-fluid">
            <div className="my-4">
                <span className="card-label font-weight-bolder c-pointer" onClick={() => history.push('/jobs')}>{t("jobsManagement.infoJob.manageJobs")}</span>
                <span className="card-label font-weight-bolder mx-2">/</span>
                <span className="card-label font-weight-bolder text-dark">{jobID}</span>
                {data?.refundId && <button className='btn btn-primary mx-2' onClick={() => history.push(`/refunds/${data?.refundId}`)}>Go to RefundInfo</button>}
            </div>
            {loading ? <div className="d-flex align-items-center justify-content-center h-75vh"><Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{ textAlign: 'center' }} /></div>
                : <div>
                    {data?.jobInfo?.status === 'PaymentRefundRequest' && <div className="alert alert-danger mt-2" style={{ position: 'sticky', top: '0', zIndex: '1', backgroundColor: 'red' }} role="alert">
                        <h5 style={{ color: 'white' }}>{CONFIG.refundRequestMessage}</h5>
                    </div>}
                    <div className="row col-lg-12">
                        <div className="col-lg-8">
                            <div className="card card-custom card-stretch gutter-b">
                                <div className="card-header border-0 d-flex justify-content-between">
                                    <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.customerInfo.title")}</h3>
                                    <div className="d-flex">
                                        {/* <button style={{minWidth: '100px'}} className="btn btn-primary me-2" onClick={handleCreateDeliveryReq}>{t("jobsManagement.infoJob.createDeliveryRequest.title")}</button> */}
                                        {(userData.Role === 'SUPERADMIN') && (data?.isPayable) && <button style={{ minWidth: '150px' }} className="btn btn-primary me-2" onClick={() => setPaymentLink(true)}>{t("jobsManagement.infoJob.createDeliveryRequest.sendPaymentLink")}</button>}
                                        <button style={{ minWidth: '150px' }} className="btn btn-primary me-2" onClick={() => setCustomDocumentModal(true)}>{t("jobsManagement.infoJob.customDocuments.title")}</button>
                                        <button style={{ minWidth: '100px' }} className="btn btn-primary me-2" onClick={() => setCreateNoteModal(true)}>{t("jobsManagement.infoJob.createNote")}</button>
                                        <select className="form-select status_change" value={status} onChange={e => { setStatus(e.target.value); setStatusModal(true) }}>
                                            <option value="" disabled={true}>{t("jobsManagement.infoJob.jobStatus.selectJobStatus")}</option>
                                            <option value="EmailDocuments">Email Documents</option>
                                            {(data?.refundStatus != null) ?
                                                <>
                                                    {['RefundCompleted'].includes(data.refundStatus) && data?.jobInfo?.status !== 'Completed' ?
                                                        <>
                                                            {statusList?.filter(({ value }) => ['Cancelled', 'Completed'].includes(value) === true).map(({ label, value }) => <option key={value} value={value}>{label}</option>)}
                                                        </> : ['RefundReject'].includes(data.refundStatus) && data?.jobInfo?.status !== 'AssignedToTypingCenter' ?
                                                            <>
                                                                {statusList?.filter(({ value }) => ['AssignedToTypingCenter'].includes(value) === true).map(({ label, value }) => <option key={value} value={value}>{label}</option>)}
                                                            </> : ['RefundRequest'].includes(data.refundStatus) ?
                                                                <></> : <></>
                                                    }
                                                </>
                                                : data?.jobInfo?.status === 'AwaitingResponse' ?
                                                    <>
                                                        {statusList?.filter(({ value }) => ['AssignedToTypingCenter'].includes(value) === true).map(({ label, value }) => <option key={value} value={value}>{label}</option>)}
                                                    </> : data.jobInfo?.status === 'PaymentRefundRequest' ?
                                                        <>
                                                            {statusList?.filter(({ value }) => ['Cancelled', 'Completed'].includes(value) === true).map(({ label, value }) => <option key={value} value={value}>{label}</option>)}
                                                        </> :
                                                        <>
                                                            {/* {statusList?.filter(({value}) => ['EmailDocuments'].includes(value) === true).map(({ label, value }) => <option key={value} value={value}>{label} </option>)} */}
                                                        </>
                                            }
                                        </select>
                                    </div>
                                </div>
                                {(data.jobInfo &&
                                    <div className="card-body pt-0 pb-3">
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.id")} : </span> {data.jobInfo.jobId}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.dateTime")} : </span> {data.jobInfo.date}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.user")} : </span> {data.customerInfo.name}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.department")} : </span> {data.jobInfo.departmentName}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.masterProcess")} : </span> {data.jobInfo.masterProcessName}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.process")} : </span> {data.jobInfo.processName}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            {data.vendorInfo && <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.cspName")} : </span>} {data.vendorInfo.typingCenterName}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            {data.vendorInfo && <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.agentName")} : </span>} {data.vendorInfo.name}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.status")} : </span> {data.jobInfo.jobStatusValue}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                                            <span className="text-muted">{t("refunds.refundStatus")} : </span> <span style={{ fontWeight: 'bold' }}>{data?.refundStatusValue ? data?.refundStatusValue : '-'}</span>
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.approvedBy")} : </span> {data.jobInfo.approvedBy === null ? '-' : data.jobInfo.approvedBy}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("jobsManagement.infoJob.customerInfo.approvedTime")} : </span> {data.jobInfo.approvedTime === null ? '-' : dateTimeFormat(data.jobInfo.approvedTime)}
                                        </div>
                                        <hr className="hr-dashed" />
                                        <div className="form-group fv-plugins-icon-container">
                                            <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.jobInfo.title")}</h3>
                                            <div className="mt-2">
                                                {(Object.entries(displayData).length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : ((Object.entries(displayData).length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : Object.entries(displayData).map(([key, value]) =>
                                                    <p className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }} key={key}><span className="text-muted">{key} : </span> {value}</p>
                                                ))}
                                            </div>
                                        </div>
                                        <hr className="hr-dashed" />
                                        <div className="form-group fv-plugins-icon-container">
                                            <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.noteInfoTitle")}</h3>
                                            <div className="mt-2" style={{ maxHeight: '300px', overflow: 'auto' }}>
                                                {(data.jobNotes.length === 0)
                                                    ? <p className="text-muted ">{t("jobsManagement.noDataAvailable")}</p>
                                                    : data.jobNotes.map(({ id, createdTime, note, createdBy }) => {
                                                        return (
                                                            <div key={id}>
                                                                <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '0px', paddingBottom: '5px' }}>
                                                                    {data.jobNotes && <span className="text-muted">{t("Date")} : </span>} {dateTimeFormat(createdTime)}
                                                                </div>
                                                                <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '0px', paddingBottom: '5px' }}>
                                                                    <span className="text-muted">{t("Note")} : </span> {note ? isReadMore === id ? note : note.slice(0, 220) : '-'}
                                                                    {
                                                                        (note && (note.length > 220))
                                                                            ? data.jobNotes && <span onClick={() => setIsReadMore(isReadMore === id ? '' : id)} style={{ cursor: 'pointer', color: '#0f8bc9' }}> {isReadMore !== id ? "...show more" : "...show less"}</span>
                                                                            : null
                                                                    }
                                                                </div>
                                                                <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                                                    {data.jobNotes && <span className="text-muted">{t("Created By")} : </span>} {createdBy}
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    )}
                                            </div>
                                        </div>
                                        <hr className="hr-dashed" />
                                        <div className="form-group fv-plugins-icon-container">
                                            <div className="d-flex justify-content-between">
                                                <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.documents")}</h3>
                                                {(fileArr.length !== 0) && <button disabled={zipLoading} className="btn btn-primary d-flex align-items-center" onClick={() => handleDownloadAllDocument("documents")}>
                                                    {t("jobsManagement.infoJob.downloadAll")}
                                                    {zipLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{ marginLeft: '10px' }} />}
                                                </button>}
                                            </div>
                                            <div className="mt-1 d-flex flex-wrap">
                                                {(Object.entries(jobData).length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : ((fileArr.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : fileArr.map(({ key, thumbnailUri, fileName, documentId }) => {
                                                    let imgType = fileName && (fileName.includes('png') || fileName.includes('jpeg') || fileName.includes('jpg'));
                                                    return (
                                                        <div key={key} className="document font-weight-bold my-2 me-2">
                                                            <div style={{ width: '-webkit-fill-available', height: '-webkit-fill-available', margin: '0 auto' }}>
                                                                {imgType ? <img src={thumbnailUri} alt="Thumbnail" width="100%" height="100%" />
                                                                    : <img src={'/Assets/nopreview_all.png'} alt="Thumbnail" style={{ width: '200px', height: '150px' }} />}
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between position-absolute bottom-0 bg-white p-2 " style={{ width: '100%' }}>
                                                                <p className="m-0">{getDocumentLabel(key, true)}</p>
                                                                <FiDownload onClick={() => handleDownloadDocument(documentId)} className="c-pointer" />
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {(corporateJobDocumentFileArr.length > 0) ?
                            <DocumentDisplay 
                                t={t} 
                                type={'corporate'}
                                fileArr={corporateJobDocumentFileArr} 
                                docArr={corporateJobDocumentFileArr} 
                                zipLoading={zipLoading2} 
                                getDocumentLabel={getDocumentLabel}
                                handleDownloadPaymentReceipt={handleDownloadPaymentReceipt}
                                handleDownloadAllDocument={handleDownloadAllDocument}
                            />
                        :""}
                            <DocumentDisplay 
                                t={t} 
                                type={'vendor'}
                                fileArr={fileArr}
                                docArr={vendorDocArr}
                                zipLoading={zipLoading1}
                                getDocumentLabel={getDocumentLabel}
                                handleDownloadPaymentReceipt={handleDownloadPaymentReceipt}
                                handleDownloadAllDocument={handleDownloadAllDocument}
                            />
                            <DocumentDisplay
                                t={t}
                                type={'custom'}
                                fileArr={fileArr}
                                docArr={customDocArr}
                                zipLoading={zipLoading2}
                                getDocumentLabel={getDocumentLabel}
                                handleDownloadPaymentReceipt={handleDownloadPaymentReceipt}
                                handleDownloadAllDocument={handleDownloadAllDocument}
                            />
                            <div className="col-lg-12">
                                <ReferenceList t={t} data={referenceReceiptList} jobID={jobID} setReferenceModal={setReferenceModal} setReferenceStatusModal={setReferenceStatusModal} setReferenceEditData={setReferenceEditData} setReceiptModal={setReceiptModal} />
                            </div>
                            <div className="col-lg-12">
                                <SubProcessList t={t} subData={subData} />
                            </div>
                            <div className="col-lg-12">
                                <AdditionalPayment t={t} additionalPaymentInfo={additionalPaymentInfo} updateStatus={updateStatus} jobID={jobID} />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">{t("jobsManagement.infoJob.sla.title")}</h4>
                                </div>
                                <div className="card-body">
                                    {data.slaInfo && <div>
                                        <p className="mb-2"><span className="text-muted">{t("jobsManagement.infoJob.sla.timeElapsed")}:</span> {data.slaInfo.timeElapsed}</p>
                                        <p className="mb-2"><span className="text-muted">{t("jobsManagement.infoJob.sla.timeRemaining")}:</span> {data.slaInfo.timeRemaining}</p>
                                        <div className="d-flex align-items-center">
                                            <span className="text-muted">{t("jobsManagement.infoJob.sla.percentage")}:</span>
                                            <div className="progress ms-2" style={{ height: '1rem', width: '100%' }}>
                                                <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: (data.slaInfo.slaPercentage + '%'), background: (data.slaInfo.slaPercentage <= 30 ? 'yellow' : (data.slaInfo.slaPercentage <= 70 ? 'green' : 'red')) }} aria-valuenow={data.slaInfo.slaPercentage} aria-valuemin="0" aria-valuemax="100">{data.slaInfo.slaPercentage}</div>
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">{t("jobsManagement.infoJob.statusInfo")}</h4>
                                </div>
                                <StatusLog t={t} statusLog={statusLog} />
                            </div>
                        </div>
                    </div>
                    {(data && data.jobInfo && ((data.jobInfo.status === 'RequestCompletion') || (data.jobInfo.status === 'RequestCancellation')))
                        && <div className='d-flex flex-column align-items-center my-4 border py-4'>
                            <p className='mb-3'>{t("jobsManagement.infoJob.jobStatus.title")}</p>
                            <div className='d-flex'>
                                <button onClick={() => { setStatus('RequestCancellation'); setStatusModal(true) }} className="btn btn-secondary font-weight-bolder font-size-sm me-3">{t("jobsManagement.infoJob.jobStatus.decline")}</button>
                                <button onClick={() => { setStatus('RequestCompletion'); setStatusModal(true) }} className="btn btn-primary font-weight-bolder font-size-sm">{t("jobsManagement.infoJob.jobStatus.accept")}</button>
                            </div>
                        </div>}
                    {statusModal && <StatusModal
                        t={t}
                        status={status}
                        documentArr={fileArr}
                        documentReason={documentReason}
                        jobId={data.jobInfo && data.jobInfo.jobId}
                        handleDocumentReason={handleDocumentReason}
                        showModal={statusModal}
                        subjectOptions={subjectOptions}
                        subject={subject}
                        setSubject={setSubject}
                        comment={comment}
                        mailDocuments={mailDocuments}
                        setMailDocuments={setMailDocuments}
                        setComment={setComment}
                        loading={buttonLoading}
                        handleOk={() => { (status === 'EmailDocuments') ? handleUpdateEmailDocuments() : (['AssignedToTypingCenter', 'Cancelled', 'Completed'].includes(status)) ? handleUpdateStatus() : handleJobClosureApproval() }}
                        handleCancel={() => { setStatusModal(false); setStatus('') }} />}
                </div>
            }
            {createNoteModal && <CreateNoteModal disabled={note.length === 0 || note.length > 100 || buttonLoading} loading={buttonLoading} t={t} showModal={createNoteModal} setNote={setNote} handleOk={() => handleCreateNote()} handleModalClose={() => setCreateNoteModal(false)} />}
            {referenceStatusModal && <ReferenceStatusModal t={t} showModal={referenceStatusModal} loading={buttonLoading} handleOk={handleUpdateReferenceStatus} handleCancel={() => setReferenceStatusModal(false)} referenceEditData={referenceEditData} />}
            {referenceModal && <ReferenceModal
                t={t}
                receiptData={receiptData}
                receiptOptions={receiptOptions}
                referenceEditData={referenceEditData}
                jobId={data.jobInfo && data.jobInfo.jobId}
                showModal={referenceModal}
                loading={buttonLoading}
                handleOk={handleUpdateReference}
                handleCancel={() => setReferenceModal(false)}
            />}
            {receiptModal && <ReceiptModal
                t={t}
                showModal={receiptModal}
                referenceEditData={referenceEditData}
                loading={buttonLoading}
                handleCancel={() => setReceiptModal(false)}
            />}
            {customDocumentModal && <CustomDocumentModal
                t={t}
                jobId={data.jobInfo && data.jobInfo.jobId}
                showModal={customDocumentModal}
                loading={buttonLoading}
                handleCancel={() => setCustomDocumentModal(false)}
                handleOk={() => setCustomDocumentModal(false)}
            />}
            {paymentLink && <PaymentLink
                t={t}
                showModal={paymentLink}
                loading={buttonLoading}
                handleCancel={() => setPaymentLink(false)}
                data={data.jobInfo.jobId}
            />}
        </div>
    );
};

export default JobInfo;